import { GastroGenericProductDetails, GastroProduct, GastroProductData } from '@modules/gastro-generic/models'
import * as React from 'react'
import { toDefaultDateFormat } from '@helpers/date-formatter'

export const getGastroCardPromo20272028Data = (
  productDetails: GastroGenericProductDetails,
  gastroProduct: GastroProduct,
): GastroProductData => {
  const offerName = 'Podwójna Radość na lata 2027/2028'

  return {
    labelImageSrc: 'gastro-voucher-label.jpg',
    productName: gastroProduct.product_name,
    productHeader: (
      <span className="font-lg">
        Skorzystaj ze specjalnej promocji na <strong className="text-nowrap">Voucher “{offerName}”</strong> do
        wykorzystania we wszystkich otwartych punktach gastronomicznych (włącznie z restauracją) podczas pobytów w
        Resortach.
      </span>
    ),
    benefitsPoints: [
      'Zakup vouchera umożliwia dokonanie zakupów z oferty gastronomicznej do wysokości wpłaconej kwoty powiększonej o 100%.',
      'Ilość voucherów, jakie możesz kupić jest nieograniczona!',
      'Voucher możesz wykorzystać we wszystkich otwartych punktach gastronomicznych na terenie Resortu.',
      'Voucher jest wielokrotnego użytku, w różnych rezerwacjach.',
    ],
    benefitsList: [
      'Minimalna wartość zamówienia to 500,00 zł',
      'Z vouchera możesz korzystać wiele razy, przypisać go do wielu rezerwacji i przy każdej wykorzystać tylko jego część aż do momentu całkowitego wykorzystania.',
      'Korzystaj w Kawiarni, Bistro, Beach Barze i Słodkim Kąciku oraz w Restauracji!',
      `Voucher można wykorzystać podczas pobytów w terminie ${toDefaultDateFormat(
        productDetails.active_after,
      )} - ${toDefaultDateFormat(productDetails.expire_after)}.`,
      'Voucher jest rozliczany według cen standardowych i nie łączy się z promocjami resortowymi.',
    ],
    alertText:
      'Voucher nie łączy się z promocją Doładowanie Smaku i Strzał w dziesiątkę. Nie można go wykorzystać w rezerwacji, do której przypisany jest jakikolwiek voucher gastronomiczny.',
  }
}
